import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {User, ability} from './modules/UserVuex'

import Client from './modules/ClientVuex'
import Litigation from './modules/LitigationVuex'
import Transaction from './modules/TransactionVuex'
import Bill from './modules/BillVuex'
import Expense from './modules/ExpenseVuex'
import Supplier from './modules/SupplierVuex'

import Status from './modules/StatusVuex'

export const store = new Vuex.Store({
  modules: {
    User,
    Client,

    // Litigation,
    // 
    // Transaction,
    // Bill,
    // Expense,

    //SP-future
    Supplier,
    Bill,
    
    Status,
  }
});


// cadastros de 
// Client
// >> contratos do cliente
// >> >> Processos do contrato

// usuarios & cargo

// mostrar faturas de taxas em aberto





// mostrar faturas de taxas por cliente //pra depois 



export const Ability = ability;
